import { useEffect,useState } from 'react';

import { useAppDispatch } from 'app/hooks';
import {
    setSaveButtonEnabled,
} from 'common/components/EditDrawer/editDrawerSlice';

export function useClaimValueInput(
    isDrawerOpened: boolean,
    claimValueToEdit: string,
    isEditOperation: boolean,
): {
    claimValue: string,
    isClaimValueInConflict: boolean,
    setIsClaimValueInConflict: (value: React.SetStateAction<boolean>) => void,
    handleClaimValueChange: (value: string) => void
    } {
    const [claimValue, setClaimValue] = useState<string>('');
    const [isClaimValueInConflict, setIsClaimValueInConflict] = useState<boolean>(false);
    const dispatch = useAppDispatch();

    useEffect(() => {
        if(isEditOperation) {
            const initialClaimValue = isDrawerOpened ? claimValueToEdit || '' : '';
            setClaimValue(initialClaimValue);
            setIsClaimValueInConflict(false);
            dispatch(setSaveButtonEnabled(false));
        }
    }, [isDrawerOpened]);

    const handleClaimValueChange = (value: string) => {
        let shouldEnableSaveButton = false;
        setClaimValue(value);
        if (isEditOperation) {
            shouldEnableSaveButton = !!value;
        }
        dispatch(setSaveButtonEnabled(shouldEnableSaveButton));
    };

    return {
        claimValue,
        isClaimValueInConflict,
        setIsClaimValueInConflict,
        handleClaimValueChange
    };
}
